export const namespace = 'books'
